var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPopupIconWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 28C4 14.7452 14.7452 4 28 4C41.2548 4 52 14.7452 52 28C52 41.2548 41.2548 52 28 52C14.7452 52 4 41.2548 4 28Z",
    fill: "#FEF0C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9998 23.9992V27.9992M27.9998 31.9992H28.0098M26.2898 18.8592L17.8198 32.9992C17.6451 33.3017 17.5527 33.6445 17.5518 33.9937C17.5508 34.343 17.6413 34.6864 17.8142 34.9898C17.9871 35.2931 18.2365 35.546 18.5375 35.7231C18.8385 35.9002 19.1806 35.9954 19.5298 35.9992H36.4698C36.819 35.9954 37.1611 35.9002 37.4621 35.7231C37.7631 35.546 38.0124 35.2931 38.1854 34.9898C38.3583 34.6864 38.4488 34.343 38.4478 33.9937C38.4468 33.6445 38.3544 33.3017 38.1798 32.9992L29.7098 18.8592C29.5315 18.5653 29.2805 18.3223 28.981 18.1537C28.6814 17.9851 28.3435 17.8965 27.9998 17.8965C27.656 17.8965 27.3181 17.9851 27.0186 18.1537C26.7191 18.3223 26.468 18.5653 26.2898 18.8592Z",
    stroke: "#DC6803",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 48C16.9543 48 8 39.0457 8 28H0C0 43.464 12.536 56 28 56V48ZM48 28C48 39.0457 39.0457 48 28 48V56C43.464 56 56 43.464 56 28H48ZM28 8C39.0457 8 48 16.9543 48 28H56C56 12.536 43.464 0 28 0V8ZM28 0C12.536 0 0 12.536 0 28H8C8 16.9543 16.9543 8 28 8V0Z",
    fill: "#FFFAEB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupIconWarning);
export default __webpack_public_path__ + "static/media/PopupIconWarning.d645ec78b079d0b59d86445096af2cab.svg";
export { ForwardRef as ReactComponent };